export default __webpack_public_path__ + "assets/e569aa311b0143f42afbd8df6e0050e2.svg";